import React from "react";

interface FullPageSpinnerProps {
  show: boolean;
}

const FullPageSpinner: React.FC<FullPageSpinnerProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-white"></div>
    </div>
  );
};

export default FullPageSpinner;